import ReelComponent from "slotworks/components/matrix/reel/reel-component";
import SlotDefinition from "slotworks/model/slot-definition";
import { wrapIndex } from "slotworks/utils/collection-utils";
import { ReelstripPosition } from "./reel-spinner";
import { ReelSpinnerResultBuffer } from "./reel-spinner-result-buffer";

export default class StandardReelSpinnerResultBuffer implements ReelSpinnerResultBuffer {

    // Force a number of symbols to buffer the result with. Otherwise default will be used ((reelsize - 1) * 2 + 1)
    public static customBufferSize: number = -1;

    protected reel: ReelComponent;

    public init(reel: ReelComponent) {
        this.reel = reel;
    }

    public getBufferSize(result: ReelstripPosition, current: ReelstripPosition): number {
        if (StandardReelSpinnerResultBuffer.customBufferSize >= 0) {
            return StandardReelSpinnerResultBuffer.customBufferSize;
        }
        return (this.reel.size - 1) * 2 + 1;
    }

    public generateResultBuffer(incoming: string[], result: ReelstripPosition, current: ReelstripPosition) {
        this.log(this.reel.index, "Incoming", incoming);
        let randomBufferStart = this.reel.size + 1;
        let randomBufferEnd = incoming.length;

        // If stacks are present before or after buffer, buffer should not contain stacks
        let forbidStacks = false;

        // Check if a stack is already in view and needs to be finished & by how much
        const currentTopSymbol = SlotDefinition.getSymbolDefinition(wrapIndex(current.index, current.reelstrip));
        this.log(this.reel.index, "TOP", current.index, currentTopSymbol.id);
        if (currentTopSymbol.size > 1) {

            // Get remaining size of stack
            let remainingSize = currentTopSymbol.size - 1;
            for (let y = 1; y <= currentTopSymbol.size; y++) {
                const nextSymbol = SlotDefinition.getSymbolDefinition(wrapIndex(current.index + y, current.reelstrip));
                if (nextSymbol.id === currentTopSymbol.id) {
                    remainingSize--;
                } else {
                    break;
                }
            }

            forbidStacks = true;
            randomBufferEnd = incoming.length - remainingSize;

            // Finish off stack
            while (remainingSize > 0) {
                incoming.splice(incoming.length - remainingSize, 1, currentTopSymbol.id);
                remainingSize--;
            }

            this.log(this.reel.index, "Finishing off stack", incoming);
        }

        // As above but for the result
        const bottomResultSymbol = SlotDefinition.getSymbolDefinition(incoming[this.reel.size]);
        this.log(this.reel.index, "BOTTOM", bottomResultSymbol.id);
        if (bottomResultSymbol.size > 1) {

            // Get remaining size of stack
            let remainingSize = bottomResultSymbol.size - 1;
            for (let y = 1; y < bottomResultSymbol.size; y++) {
                const nextSymbol = SlotDefinition.getSymbolDefinition(incoming[this.reel.size - y]);
                if (nextSymbol.id === bottomResultSymbol.id) {
                    remainingSize--;
                } else {
                    break;
                }
            }

            forbidStacks = true;
            randomBufferStart = this.reel.size + remainingSize + 1;

            this.log(this.reel.index, "Adding in remaining wilds below result", remainingSize);

            // Finish off stack
            while (remainingSize > 0) {
                incoming.splice(this.reel.size + remainingSize, 1, bottomResultSymbol.id);
                remainingSize--;
            }

            this.log(this.reel.index, "Introducing stack", incoming);
        }

        this.log(this.reel.index, "FILLING IN BUFFER", randomBufferStart, randomBufferEnd, incoming);

        // Fill remaining space with non-wild result symbols
        const symbolPool = [...result.reelstrip];
        // Remove actual result from symbolPool
        for (let i = 0; i < this.reel.size + 2; i++) {
            symbolPool.splice(result.index, 1);
        }

        let r = Math.floor(Math.random() * symbolPool.length);
        for (let y = randomBufferStart; y < randomBufferEnd; y++) {
            if (r > symbolPool.length - 1) {
                r--;
            }
            const symbol = symbolPool.splice(r, 1)[0];
            const symbolDef = SlotDefinition.getSymbolDefinition(symbol);

            if (!forbidStacks || symbolDef.size === 1) {
                // Stacks are allowed in buffer, but can only be complete stacks
                if (symbolDef.size > 1) {
                    if (y + symbolDef.size < randomBufferEnd) {
                        // Inserting a stack into buffer
                        forbidStacks = true;
                        for (let stackY = y; stackY < y + symbolDef.size; stackY++) {
                            incoming[stackY] = symbol;
                        }
                        this.log(this.reel.index, "FILL IN", symbol, symbolDef.size, incoming);
                        y += symbolDef.size - 1;
                    } else {
                        // Stack won't fit, try next symbol
                        y--;
                    }
                } else {
                    // Suitable symbol found
                    incoming[y] = symbol;
                    this.log(this.reel.index, "FILL IN", symbol, incoming);
                }
            } else {
                // Symbol not suitable, try next
                y--;
            }
        }

        this.log(this.reel.index, "Final incoming", incoming);
    }

    private log(...args: any[]) {
        // Logger.info("%c Reel spinner - buffer ", "background: #f4e242; color: #333", ...args);
    }
}
